<template>
  <div>

    <h1 style="font-size: 24px; color: black;">背包管理</h1>

    <div style="margin-bottom: 10px;">

      <table>
        <tr>
          <td>
            <el-button type="primary" @click="editDialogFun(true,'新增奖品')">新增</el-button>
          </td>
        </tr>
          <td>
            <el-upload :action="upload()" :headers="headers"
                       :on-success="handleZipSuccess"
                       :before-upload="beforeZipUpload"
                       :show-file-list="false"
                       v-loading.fullscreen.lock="loading"
                       ref="upload">
              <el-button size="medium" type="primary">批量新增</el-button>
            </el-upload>
          </td>
      </table>
    </div>

    <div>
      <el-table border :data="prizes">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column prop="id"    label="id" >  </el-table-column>
        <el-table-column prop="type"    label="类型"  :formatter="typeFormatter">  </el-table-column>
        <el-table-column prop="name" label="物品名称"></el-table-column>
        <el-table-column  label="过期时间">
          <template slot-scope="scope">
            {{ scope.row.isForever ? '永久': scope.row.expireDays+"天"  }}
          </template>
        </el-table-column>
        <el-table-column  label="碎片位置">
          <template slot-scope="scope">
            {{ scope.row.position ?scope.row.position: ""  }}
          </template>
        </el-table-column>
         <el-table-column  label="对应实物" prop="parentId" :formatter="parentIdFormatter">
          <!-- <template slot-scope="scope">
            {{ scope.row.parentId ? scope.row.parentId:  ""  }}
          </template> -->
        </el-table-column>
        <el-table-column prop="parameter" label="其他参数"></el-table-column>
        <el-table-column label="缩略图">
          <template slot-scope="scope">
            <template v-if="scope.row.smallImage">
              <img :src="VUE_APP_CDN_URL+scope.row.smallImage" width="80px" height="80px" alt=""/>
            </template>
          </template>
        </el-table-column>
         <el-table-column label="大图">
          <template slot-scope="scope">
            <template v-if="scope.row.bigImage">
              <img :src="VUE_APP_CDN_URL+scope.row.bigImage" width="80px" height="80px" alt=""/>
              <!-- <span>{{VUE_APP_CDN_URL+scope.row.bigImage}}</span> -->
            </template>
          </template>
        </el-table-column>
         <el-table-column label="开关" align="center" width="150px">
         <template slot-scope="scope">
                    <el-switch v-model="scope.row.isUse"
                               :active-value="true"
                               :inactive-value="false"
                               active-text="开启"
                               inactive-text="关闭"
                               @change="update(scope.row)">
                    </el-switch>
           </template>
        </el-table-column>
        <el-table-column     label="是否可见" >
          <template slot-scope="scope">
            {{ scope.row.isSee ?  '可见': '不可见' }}
          </template>
        </el-table-column>
        <el-table-column prop="createDt" label="创建时间" :formatter="formatDate"></el-table-column>
        <el-table-column prop="updateDt" label="更新时间" :formatter="formatDate"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button plain size="mini" type="success" @click="editDialogFun(true,'编辑',scope.row)">编辑</el-button> 
          </template>
        </el-table-column>
      </el-table>
    </div>
 

    <el-dialog :title="editDialog.title" center :visible.sync="editDialog.show" width="40%" :data="prize">
      <table style = "border-collapse:separate; border-spacing:30px;">
        <tr>
          <td><span>奖品类型：</span></td>
          <td colspan="2">
            <el-select v-model="prize.type" filterable placeholder="请选择/输入"  >
              <el-option
                  v-for="item in typeValues"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </td>
        </tr>
        <tr>
          <td><span>名称:</span></td>
          <td colspan="2"> 
          <el-input   style="width: 220px" type="text" maxlength="10" placeholder="不超过10个字符" v-model="prize.name"></el-input> 
          </td>
        </tr>
        <tr>
          <td><span>是否为永久:</span></td>
          <td colspan="2"> 
          <el-switch v-model="prize.isForever"
                               :active-value="true"
                               :inactive-value="false"
                               active-text="是"
                               inactive-text="否" >
                    </el-switch>
          </td>
        </tr>
        <tr v-if="prize.isForever!==true">
          <td><span>有效时间(天):</span></td>
          <td colspan="2"> 
          <el-input-number  :min="0" :max="100" tyle="width: 220px" type="text" v-model="prize.expireDays"> </el-input-number>
          </td>
        </tr>
        <tr>
          <td><span>是否有效:</span></td>
          <td colspan="2"> 
          <el-switch v-model="prize.isUse"
                               :active-value="true"
                               :inactive-value="false"
                               active-text="是"
                               inactive-text="否" >
                    </el-switch>
          </td>
        </tr>
        <tr>
          <td><span>是否可见:</span></td>
          <td colspan="2"> 
          <el-switch v-model="prize.isSee"
                               :active-value="true"
                               :inactive-value="false"
                               active-text="是"
                               inactive-text="否" >
                    </el-switch>
          </td>
        </tr>
        <tr v-if="prize.type==3">
          <td><span>碎片位置:</span></td>
          <td colspan="2"> 
            <el-input-number  :min="1" :max="27" tyle="width: 220px" type="text" v-model="prize.position"> </el-input-number>
          </td>
        </tr>
        <tr v-if="prize.type==3">
          <td><span>父级节点:</span></td>
          <td colspan="2"> 
              <el-select v-model="prize.parentId" filterable placeholder="请选择/输入"  >
              <el-option
                  v-for="item in prizes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </td>
        </tr>
        <tr >
          <td><h1>其他配置:</h1></td>
        </tr> 
        <tr >
          <td><span>额外参数:</span></td>
          <td colspan="2"> 
            <el-input   style="width: 220px" type="text" :rows="2"  placeholder="请输入" v-model="prize.parameter"> </el-input>
          </td>
        </tr>
        <tr v-if="prize.type!==3">
          <td><span>介绍:</span></td>
          <td colspan="2"> 
          <el-input   style="width: 220px" type="textarea" :rows="2"  placeholder="请输入内容" v-model="prize.detail"></el-input> 
          </td>
        </tr>
        <tr v-if="prize.type!==3">
          <td><span>小图：</span></td>
          <td>
            <el-upload :headers="headers"
                       class="avatar-uploader"
                       :action="uploadURL"
                       :show-file-list="false"
                       :on-success="handleImageSmallImageSuccess"
                       :before-upload="beforeImageUpload">
              <img v-if="prize.smallImage" :src="VUE_APP_CDN_URL+prize.smallImage" class="avatar" alt=""/>
              <i v-else class="el-icon-picture avatar-uploader-icon"></i>
            </el-upload> 
          </td>
          <td><span>缩略图支持.png 或.jpg 格式，且不超过500kb</span></td>
        </tr>
         <tr v-if="prize.type!==3">
          <td><span>大图：</span></td>
          <td>
            <el-upload :headers="headers"
                       class="avatar-uploader"
                       :action="uploadURL"
                       :show-file-list="false"
                       :on-success="handleImageBigImageSuccess"
                       :before-upload="beforeImageUpload">
              <img v-if="prize.bigImage" :src="VUE_APP_CDN_URL+prize.bigImage" class="avatar" alt=""/>
              <i v-else class="el-icon-picture avatar-uploader-icon"></i>
            </el-upload> 
          </td>
          <td><span>缩略图支持.png 或.jpg 格式，且不超过500kb</span></td>
        </tr>
        <tr>
          <td style="text-align-last: center;" colspan="3">
            <el-button plain size="middle" type="success" @click="saveOrUpdatePrize">确定</el-button>
            <el-button plain size="middle" type="danger" @click="editDialogFun(false)">返回</el-button>
          </td>
        </tr>
      </table>

    </el-dialog>

    <el-dialog :title="messageDialog.title" center :visible.sync="messageDialog.show" width="30%">
      <h1 v-html="messageDialog.message"/>
      <el-button plain size="mini" type="success" @click="messageDialogFun(false)">确定</el-button>
    </el-dialog>

  </div>

</template>

<script>
import utils from '@/utils'
import { 
     
  typePacketInfo, allPacketList,changeStatePacket,addPacket,editPacket} from "@/http/api";

export default {
  inject: ['reload'],
  name: "PacketList",
  data() {
    return {
      loading: false,
      editDialog: {
        show: false,
        title: null
      },
      VUE_APP_BASE_URL: null,
      VUE_APP_CDN_URL: null,
      uploadURL: process.env.VUE_APP_BASE_URL + "game/upload",
      typeValues: [ ], 
      prize: {
        id: null,
        type: null,
        name: null,
        expireDays:null,
        isForever: null,
        bigImage: null,
        smallImage: null,
        detail: null,
        isUse:null,
        isSee:null,
        position:null,
        parentId:null,
        parameter:null
      }, 
      prizes: null,
      //编辑标志位
      editFlag : false, 
      headers: {},
      messageDialog: {
        show: false,
        title: null,
        message: null
      } 
    }
  },
  methods: {
    formatDate: function(row, column, cellValue) {
                return utils.DateUtil.formatDate(cellValue, "yyyy-MM-DD HH:mm:ss")
     },
    typeFormatter: function (row, column, cellValue){
      var temp="其他"
      this.typeValues.forEach( item => {
        if(item.id===cellValue){
               temp=item.name;
            } 
      })
      return temp
    },
    parentIdFormatter: function (row, column, cellValue){
      var temp=""
      if(cellValue!==null){ 
          this.prizes.forEach( prize => {
          if(prize.id===cellValue){
                temp=prize.name; 
              } 
          } )
      }
      return temp
    },
     allPrize(){
        allPacketList().then(resp=>{
        //  console.log(resp.data.info)
        this.prizes=resp.data.info
        this.headers = {Authorization: this.$store.state.user.token};
            });
     },
    saveOrUpdatePrize() {
      if (this.prize.type == null) {
        this.$message.error('物品类型不能为空！');
        return;
      }
      if (this.prize.name == null) {
        this.$message.error('物品名称不能为空！');
        return;
      }
      if (this.prize.isForever == false) {
        if(this.prize.expireDays==0){
          this.$message.error('有效期不能为0!');
          return;
        }
        
      }
      if(this.editFlag){
        editPacket(this.prize).then(resp => {
        if (resp.data.status === 0) {
          this.editDialogFun(false);  
          this.$message.success('修改成功');
          this.reload();  
        }else{
          this.$message.error('修改失败');
        }
      });
      }else{
          addPacket(this.prize).then(resp => {
        if (resp.data.status === 0) {
          this.editDialogFun(false);  
          this.$message.success('新增成功');
          this.reload();  
        }else{
          this.$message.error('新增失败');
        }
      });
      } 
      
    }, 
      update(row){
      // 修改开关更新方法 只需要传入id即可进行转换  ------------------------------------------
      changeStatePacket(row.id).then(resp=>{
          if (resp.data.msg==='成功'){ 
             this.$message.success('修改成功');
                  // this.reload();  
          }else{
            this.$message.error('修改失败');
          }
      });
  },
  
    handleImageBigImageSuccess(data) {
      this.prize.bigImage = data.info;
    }, 
    handleImageSmallImageSuccess(data) {
      this.prize.smallImage = data.info;
    }, 
    beforeImageUpload(data) {
      const type = data.name.substring(data.name.lastIndexOf('.')) === '.png' || data.name.substring(data.name.lastIndexOf('.')) === '.jpg';
      const size = data.size < 1024 * 500;
      if (!type) {
        this.$message.error('上传图片只能是png,jgp格式!');
      }
      if (!size) {
        this.$message.error('上传图片大小不能超过500kb!');
      }
       
      return type && size;
    }, 
    upload() {
      return this.VUE_APP_BASE_URL + 'packet/upload';
    },
    editDialogFun(show, title, data) {
      this.editDialog.show = show;
      this.editDialog.title = title;
 
      this.editFlag=false;
      this.prize.id=null,
      this.prize.type= null,
      this.prize.name= null,
      this.prize.expireDays=null,
      this.prize.isForever= false,
      this.prize.bigImage= null,
      this.prize.smallImage= null,
      this.prize.detail=null,
      this.prize.isUse=false,
      this.prize.isSee=false,
      this.prize.position =null,
      this.prize.parentId=null,
      this.prize.parameter=null
      if (show && data) { 
      this.prize.id=data.id;
      this.prize.type= data.type;
      this.prize.name= data.name;
      this.prize.expireDays=data.expireDays;
      this.prize.isForever= data.isForever;
      this.prize.bigImage= data.bigImage;
      this.prize.smallImage= data.smallImage;
      this.prize.detail=data.detail;
      this.prize.isUse=data.isUse;
      this.prize.isSee=data.isSee;
      this.prize.position=data.position;
      this.prize.parentId=data.parentId;
      this.prize.parameter=data.parameter;
        //设置编辑标志位
        this.editFlag=true;
      }

    },
    messageDialogFun(show, title, message) {
      this.messageDialog.show = show;
      this.messageDialog.title = title;
      this.messageDialog.message = message;
    }, 
    handleZipSuccess(data) {
      this.loading = false;
      let title;
      if (data.status === 0) {
        title = "温馨提示";
      } else {
        title = "错误提示";
      }
      this.messageDialogFun(true, title, data.msg);
       this.reload();  
    },
    beforeZipUpload(data) {
      const type = data.name.substring(data.name.lastIndexOf('.')) === '.zip';
      const size = data.size < 1024 * 1024 * 100;
      if (!type) {
        this.$message.error('上传zip只能是zip格式!');
      }
      if (!size) {
        this.$message.error('上传zip大小不能超过100m!');
      }
      let b = type && size;
      if (b) {
        this.loading = true;
        this.messageDialogFun(true, '温馨提示', '上传中，请稍候');
      }
      return type && size;
    },
  },
  created() {
     this.allPrize();
     typePacketInfo().then(resp => {
       this.typeValues=resp.data.info
     }) 
  },
  mounted() {
    this.VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL;
    this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
  }
}
</script>

<style lang="less">
.sub {
  position: relative;
  left: 570px
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 60px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 60px;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar1 {
  width: 150px;
  height: 200px;
  display: block;
}

.elalert {
  max-width: 89%;
  left: 11%;
}

.iconSize {
  font-size: 14px;
  font-weight: normal;
}

</style>
